// src/components/ui/card.jsx
import React from "react";

export function Card({ children, className, hover = false, ...props }) {
  return (
    <div
      className={`
        rounded-xl
        bg-white
        ${hover ? 'transition-all duration-300 hover:shadow-xl hover:-translate-y-1' : 'shadow-sm'}
        ${className || ""}
      `}
      {...props}
    >
      {children}
    </div>
  );
}

export function CardHeader({ children, className, bordered = false, ...props }) {
  return (
    <div
      className={`
        p-5
        ${bordered ? 'border-b' : ''}
        ${className || ""}
      `}
      {...props}
    >
      {children}
    </div>
  );
}

export function CardContent({ children, className, ...props }) {
  return (
    <div 
      className={`
        p-5
        space-y-4
        ${className || ""}
      `} 
      {...props}
    >
      {children}
    </div>
  );
}

export function CardFooter({ children, className, bordered = false, ...props }) {
  return (
    <div 
      className={`
        p-5
        ${bordered ? 'border-t' : ''}
        ${className || ""}
      `} 
      {...props}
    >
      {children}
    </div>
  );
}

export function CardTitle({ children, className, ...props }) {
  return (
    <h3 
      className={`
        font-semibold 
        text-lg 
        text-gray-900
        ${className || ""}
      `} 
      {...props}
    >
      {children}
    </h3>
  );
}

export function CardDescription({ children, className, ...props }) {
  return (
    <p 
      className={`
        text-sm 
        text-gray-600
        ${className || ""}
      `} 
      {...props}
    >
      {children}
    </p>
  );
}
